import { render, staticRenderFns } from "./addOrgan.vue?vue&type=template&id=456dd025&scoped=true&"
import script from "./addOrgan.vue?vue&type=script&lang=js&"
export * from "./addOrgan.vue?vue&type=script&lang=js&"
import style0 from "./addOrgan.vue?vue&type=style&index=0&id=456dd025&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456dd025",
  null
  
)

export default component.exports